const APP_NAME_ENUM = {
  bill: "bill",
  boss: "boss",
  owner: "owner",
  producer: "producer",
  cashierManage: "cashierManage",
  wscManage: "wscManage",
};

const appNamesMap = {
  [APP_NAME_ENUM.bill]: "开票助手",
  [APP_NAME_ENUM.boss]: "批发易",
  [APP_NAME_ENUM.owner]: "货主端",
  [APP_NAME_ENUM.producer]: "产地通",
};

// 系统标识符
export const SystemEnum = {
  ANDROID: "ANDROID",
  IOS: "IOS",
  HARMONY: "HARMONY",
  UNKNOW: "UNKNOW",
};

class DeviceUtils {
  _isPhone = false;
  _isIpad = false;
  _isFlutterPfBoss = false;
  _isMiniProgram = false;
  _isWeiXin = false;

  system = SystemEnum.UNKNOW;
  appType = "";
  constructor() {
    this.initAppType();
    this.initIsPhone();
    this.initSystem();
  }

  initAppType() {
    const ua = navigator.userAgent.toLowerCase();
    if (ua.indexOf("senguo:pfbillapp") > -1) {
      this.appType = APP_NAME_ENUM.bill;
    } else if (ua.indexOf("senguo:pfbossapp") > -1) {
      this.appType = APP_NAME_ENUM.boss;
    } else if (ua.indexOf("senguo:pfownerapp") > -1) {
      this.appType = APP_NAME_ENUM.owner;
    } else if (ua.indexOf("senguo:producerapp") > -1) {
      this.appType = APP_NAME_ENUM.producer;
    } else if (ua.indexOf("senguo:cashiermanageapp") > -1) {
      this.appType = APP_NAME_ENUM.cashierManage;
    } else if (ua.indexOf("senguo:wscmanageapp") > -1) {
      this.appType = APP_NAME_ENUM.wscManage;
    }
  }

  initIsPhone() {
    const ua = navigator.userAgent.toLowerCase();
    this._isPhone = /senguo:/i.test(ua);
    this._isIpad = /iPad/i.test(ua);
    this._isFlutterPfBoss = /androidpfbosstabletapp/i.test(ua);
    this._isMiniProgram = ua.indexOf("miniprogram") > -1;
    this._isWeiXin = ua.indexOf("micromessenger") > -1;
  }

  initSystem() {
    const ua = window.navigator.userAgent;
    if (/(Android)/i.test(ua) || ua.indexOf('Adr') > -1) {
      this.system = SystemEnum.ANDROID;
    } else if (/(iPhone|iPad|iPod|iOS)/i.test(ua) || ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)) {
      this.system = SystemEnum.IOS;
    } else if (/(harmony)/i.test(ua)) {
      this.system = SystemEnum.HARMONY;
    }
  }

  // app类型
  getAppType() {
    return this.appType;
  }

  // app名称
  getAppName() {
    if (!this.getAppType()) {
      return "";
    }
    return appNamesMap[this.getAppType()];
  }

  // 获取所属项目名称
  getBuName() {
    switch (this.getAppType()) {
      case APP_NAME_ENUM.cashierManage:
        return "new_ls";
      case APP_NAME_ENUM.wscManage:
        return "wsc";
      case APP_NAME_ENUM.boss:
      case APP_NAME_ENUM.bill:
      case APP_NAME_ENUM.owner:
      case APP_NAME_ENUM.producer:
        return "pf";
    }
    return "";
  }

  getSystem() {
    return this.system;
  }

  isAndroid() {
    return this.system === SystemEnum.ANDROID;
  }

  isAndroidTablet() {
    if (this.isAndroid()) {
      // 通过宽度判断是否为平板
      const userAgent = window.navigator.userAgent.toLocaleLowerCase();
      return (
        window.innerWidth >= 600 ||
        ["eln-w09", "tb331fc", "tb-j606f"].some((v) => {
          return userAgent.includes(v);
        })
      );
    } else {
      return false;
    }
  }

  isTablet() {
    return this.isIPad() || this.isAndroidTablet();
  }

  isFlutterPfTablet() {
    return this._isFlutterPfBoss;
  }

  isMiniProgramEnv() {
    return this._isMiniProgram;
  }

  isWeiXin() {
    return this._isWeiXin;
  }

  isIos() {
    return this.system === SystemEnum.IOS;
  }

  isHarmony() {
    return this.system === SystemEnum.HARMONY;
  }

  isAndroidLikely() {
    return [SystemEnum.ANDROID, SystemEnum.HARMONY].includes(this.system);
  }

  isIPad() {
    return this._isIpad;
  }

  isPhone() {
    return this._isPhone;
  }

  // 森果云app
  isSenguoApp() {
    return Boolean(this.getAppType());
  }

  isBossApp() {
    return this.getAppType() === APP_NAME_ENUM.boss;
  }

  isOwnerOrBillApp() {
    return this.isBillApp() || this.isOwnerApp();
  }

  isOwnerApp() {
    return this.getAppType() === APP_NAME_ENUM.owner;
  }

  isBillApp() {
    return this.getAppType() === APP_NAME_ENUM.bill;
  }

  isProducerApp() {
    return this.getAppType() === APP_NAME_ENUM.producer;
  }
}

const deviceUtils = new DeviceUtils();
export default deviceUtils;
